var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMemoryIconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1473:15757",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1473:15757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#4F32CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99976 7C3.99976 5.89543 4.89519 5 5.99976 5H8.99976C9.55204 5 9.99976 5.44772 9.99976 6V13C9.99976 13.5523 9.55204 14 8.99976 14H4.99976C4.44747 14 3.99976 13.5523 3.99976 13V7ZM5.99976 6C5.44747 6 4.99976 6.44772 4.99976 7V13H8.99976L8.99976 6H5.99976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4995 6C13.2234 6 12.9995 6.22386 12.9995 6.5V12.5C12.9995 12.7761 13.2234 13 13.4995 13H16.4995C16.7757 13 16.9995 12.7761 16.9995 12.5V6.5C16.9995 6.22386 16.7757 6 16.4995 6H13.4995ZM11.9995 6.5C11.9995 5.67157 12.6711 5 13.4995 5H16.4995C17.3279 5 17.9995 5.67157 17.9995 6.5V12.5C17.9995 13.3284 17.3279 14 16.4995 14H13.4995C12.6711 14 11.9995 13.3284 11.9995 12.5V6.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9999 6C19.9999 5.44772 20.4476 5 20.9999 5H23.9999C25.1044 5 25.9999 5.89543 25.9999 7V13C25.9999 13.5523 25.5522 14 24.9999 14H20.9999C20.4476 14 19.9999 13.5523 19.9999 13V6ZM23.9999 6H20.9999V13H24.9999V7C24.9999 6.44772 24.5522 6 23.9999 6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99963 17C3.99963 16.4477 4.44735 16 4.99963 16H8.99963C9.55192 16 9.99963 16.4477 9.99963 17V24C9.99963 24.5523 9.55192 25 8.99963 25H5.99963C4.89506 25 3.99963 24.1046 3.99963 23V17ZM8.99963 17L4.99963 17V23C4.99963 23.5523 5.44735 24 5.99963 24L8.99963 24L8.99963 17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4995 17C13.2234 17 12.9995 17.2239 12.9995 17.5V23.5C12.9995 23.7761 13.2234 24 13.4995 24H16.4995C16.7757 24 16.9995 23.7761 16.9995 23.5V17.5C16.9995 17.2239 16.7757 17 16.4995 17H13.4995ZM11.9995 17.5C11.9995 16.6716 12.6711 16 13.4995 16H16.4995C17.3279 16 17.9995 16.6716 17.9995 17.5V23.5C17.9995 24.3284 17.3279 25 16.4995 25H13.4995C12.6711 25 11.9995 24.3284 11.9995 23.5V17.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9999 17C19.9999 16.4477 20.4476 16 20.9999 16H24.9999C25.5522 16 25.9999 16.4477 25.9999 17V23C25.9999 24.1046 25.1044 25 23.9999 25H20.9999C20.4476 25 19.9999 24.5523 19.9999 24V17ZM24.9999 17H20.9999V24L23.9999 24C24.5522 24 24.9999 23.5523 24.9999 23L24.9999 17Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemoryIconActive);
export default __webpack_public_path__ + "static/media/memory_icon--active.f9677369a43eee5549650515c886c086.svg";
export { ForwardRef as ReactComponent };